import $trace from '@beukay/trace';

export const trace = (event: string, params: any) => {
  $trace.track(event, params);
};

// 按钮点击打点
export const btnClickTrace = (item: API.BtnTrace) => {
  trace('btn_click', {
    ...item,
  });
};

// 首页轮播点击、精品楼层点击打点
export const linkTrace = (
  traceObj: API.BtnTrace,
  value: API.imageBindValue,
) => {
  const traceData: any = {
    btn_name: traceObj?.btn_name,
    desc: traceObj?.desc,
    link_page_url: value?.link,
    link_page_type: value?.linkType,
  };

  switch (value.linkType) {
    case 'brand_link':
      traceData.link_page_url = `/search?type=brand&k=${value?.link}`;
      traceData.link_page_type = '品牌类型';
      break;
    case 'category_link':
      traceData.link_page_url = `/search?type=display-category&k=${value?.link}`;
      traceData.link_page_type = '分类类型';
      break;
    case 'product_link':
      traceData.link_page_url = `/product/${value?.link}`;
      traceData.link_page_type = '商品类型';
      break;
    case 'search_link':
      traceData.link_page_url = `/search?k=${value?.link}`;
      traceData.link_page_type = '搜索类型';
      break;
    case 'coupon_link':
      traceData.link_page_url = `/search?type=coupon&k=${value?.link}`;
      traceData.link_page_type = '优惠券类型';
      break;
    default:
      traceData.link_page_url = value?.link;
      traceData.link_page_type = '自定义类型';
  }

  btnClickTrace(traceData);
};

// 兑换打点
export const exchangeTrace = (item: API.ExchangeTrace) => {
  trace('exchange_btn_click', item);
};

// 首页轮播图-轮播曝光打点
export const swiperTrace = (
  swiper: any,
  values: API.imageBindValue[],
  inViewport: boolean,
) => {
  if (inViewport) {
    const { realIndex = 0 } = swiper;
    const obj = values[realIndex];
    trace('exposure', {
      module_name: '广告',
      ad_space_name: 'banner',
      ad_space_type: '轮播图',
      ad_space_id: obj.image,
    });
  }
};

// 首页-品牌图点击打点
export const brandTrace = (item: API.brandSubImageValue) => {
  trace('brand_btn_click', {
    brand_name: item?.title,
    brand_id: item?.link,
  });
};

// 商品点击打点
export const productTrace = (item: API.skuDetail & { source?: string }) => {
  trace('item_window_click', {
    retail_price: item?.originalPrice,
    discount_price: item?.discountPrice,
    item_sku_code: item?.skuCode,
    item_name: item?.skuName,
    brand_name: item?.brandName,
    promotion_type: item?.activityTags?.map((option) => option.text)?.join(';'),
    source: item?.source,
  });
};

// 对话框点击打点
export const dbClickTrace = (item: API.DBTrace) => {
  trace('db_click', {
    ...item,
  });
};

// 加购打点
export const addCartTrace = (item: API.CartTrace) => {
  trace('shoppingcart_btn_click', {
    ...item,
  });
};
